var map = {
	"./bot-1.jpeg": 215,
	"./bot-2.jpeg": 7212,
	"./bot-3.jpeg": 6838,
	"./bot-4.jpeg": 6967,
	"./first-web.png": 6221,
	"./gen-trader.webp": 7057,
	"./lv188.webp": 4743,
	"./plant.webp": 2534,
	"./telegram-1.jpg": 2563,
	"./telegram-2.jpg": 5505,
	"./telegram-downline.png": 8116,
	"./telegram-profile.png": 1753,
	"./yi38.webp": 7291,
	"./yi68.webp": 6473
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;